module.exports = __webpack_public_path__ + "img/TheRiseFrameworkNavy.01372b5c.png";